import { useAppContext } from '@/hooks/useAppContext';

function relayHost(url: string): string {
  try {
    return new URL(url).host;
  } catch {
    return url.replace(/^wss?:\/\//, '').replace(/\/+$/, '');
  }
}

/** Detailed, reusable list of configured relays with read/write indicators. */
export function RelayList() {
  const { config } = useAppContext();
  const relays = config.relayMetadata.relays;
  const writeCount = relays.filter((r) => r.write).length;

  return (
    <div>
      <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
        <h3 className="text-sm font-bold text-[#333]">Relays</h3>
        <span className="text-[11px] text-[#999]">
          Posts are sent to relays marked “Write” ({writeCount})
        </span>
      </div>
      {relays.length === 0 ? (
        <p className="text-xs text-[#888]">No relays configured.</p>
      ) : (
        <ul className="flex flex-wrap gap-2">
          {relays.map((r) => (
            <li
              key={r.url}
              className="flex items-center gap-1.5 rounded-full border border-[#d6d6d6] bg-[#f6f9fc] px-2.5 py-1 text-xs"
              title={r.url}
            >
              <span className="font-medium text-[#333]">{relayHost(r.url)}</span>
              <span
                className={
                  r.read ? 'font-bold text-[#2e7d32]' : 'font-bold text-[#c4c4c4]'
                }
                title={r.read ? 'Reads events' : 'Not used for reading'}
              >
                R
              </span>
              <span
                className={
                  r.write ? 'font-bold text-[#105B86]' : 'font-bold text-[#c4c4c4]'
                }
                title={r.write ? 'Receives published events' : 'Not used for writing'}
              >
                W
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
